export default __webpack_public_path__ + "static/media/welcome-to-canvas.50388ff1.svg";